import React from "react";
import { Link } from "react-router-dom";

const Course2Header = () => {
  return (
    <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
      <Link to={`/master/course-list`} className="btn btn-primary">
        <span>Back</span>
      </Link>
    </div>
  );
};

export default Course2Header;
